import React from 'react';

function BookingCode(props) {
    return (
        <div>
            {props.bookingCode}
        </div>
    );
}

export default BookingCode;